import { inIframe } from '../../utils/inIframe';

export const checkHighestVersionStrategy = (): Promise<number | null> => {
  if (!inIframe()) {
    return Promise.resolve(getVersionWithWindowApi());
  }
  if (!window.Wix) {
    return Promise.reject(new Error('window.Wix is not available'));
  }
  return getVersionWithJsSdk();
};

const getVersionWithWindowApi = (): number | null => {
  let counter = 1;
  try {
    if (!window.ApplePaySession) {
      return null;
    }
  } catch (e) {
    return null;
  }
  try {
    /**
     * !important
     * Throws error when rendered in not same-origin iframe or on insecure (http://) document.
     * "InvalidAccessError: Trying to start an Apple Pay session from a document with an different security origin than its top-level frame."
     */
    while (window.ApplePaySession.supportsVersion(counter)) {
      counter++;
    }
  } catch (e) {
    // ignore
  }
  return counter - 1;
};

const getVersionWithJsSdk = async (): Promise<number | null> => {
  let counter = 1;

  if (!window.Wix) {
    return null;
  }

  while (await supportsVersion(counter)) {
    counter++;
  }
  return counter - 1;
};

const supportsVersion = async (counter) => {
  return new Promise<any>((res, rej) => {
    window.Wix.Pay.ApplePay.invokeMethod(
      'supportsVersion',
      { version: counter },
      (r) => {
        res(r.result);
      },
      (e) => {
        rej(e);
      },
    );
  });
};
